(() => {
  class UserPaymentMethodsController {
    constructor($scope, toastr, Users, Notifications, PaymentsService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        toastr,
        Users,
        Notifications,
        PaymentsService
      });
    }

    $onInit() {
      this.type = 'graphic';
      this.data = {
        title: 'visa',
        description: '9999'
      }; //Check for payment provider

      this.PaymentsService.getCachePaymentServiceType().then(data => {
        this.paymentProvider = data.service;
      }).catch(err => {
        this.paymentProvider = '';
        var error = 'Error: payment provider not found.';
        this.toastr.error(error);
      });
      this.getDefaultPaymentMethod();
    }

    getDefaultPaymentMethod() {
      this.Users.getDefaultPaymentMethod(this.user.id).then(({
        data
      }) => {
        this.defaultPaymentMethod = data;
      }).catch(err => {
        this.defaultPaymentMethod = null;
      });
    }

    storeNewPayment(data) {
      let paymentObj = {};

      if (this.paymentProvider === 'STRIPE') {
        paymentObj = {
          stripe: data.setupIntent,
          default: 1
        };
      } else {
        const error = 'Error: payment provider not found.';
        this.toastr.error(error);
        return;
      }

      this.paymentInProcess = true;
      this.PaymentsService.saveNewPaymentMethod(this.user.id, paymentObj).then(() => {
        this.paymentInProcess = false;
        this.toastr.success('Credit card updated successfully.');
        this.getDefaultPaymentMethod();
      }).catch(err => {
        this.paymentInProcess = false;
        let error;

        if (err && err.data && err.data.message && err.data.message.summary) {
          error = err.data.message.summary;
        } else {
          error = JSON.stringify(err);
        }

        this.toastr.error('Error updating credit card: ' + error);
        this.errorMessages = [error];
      });
    }

  }

  UserPaymentMethodsController.$inject = ["$scope", "toastr", "Users", "Notifications", "PaymentsService"];
  angular.module('pims').component('userPaymentMethods', {
    templateUrl: 'app/views/users/detail/tabs/payment-methods/payment-methods.tab.html',
    controller: UserPaymentMethodsController,
    controllerAs: 'vm',
    bindings: {
      user: '<'
    }
  });
})();